"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinePinComponentSchema = exports.isMarkerType = exports.MarkerTypeSchema = void 0;
const zod_1 = require("zod");
const shadow_setting_1 = require("../setting/shadow-setting");
const base_pin_component_1 = require("./base-pin-component");
exports.MarkerTypeSchema = zod_1.z.enum(['NONE', 'ARROW']);
const isMarkerType = (markerType) => {
    return markerType === 'NONE' || markerType === 'ARROW';
};
exports.isMarkerType = isMarkerType;
const LineSettingsSchema = base_pin_component_1.BasePinComponentSettingsSchema.merge(zod_1.z.object({
    headMarker: exports.MarkerTypeSchema.optional(),
    tailMarker: exports.MarkerTypeSchema.optional(),
    shadow: shadow_setting_1.ShadowSettingKeySchema,
    fillColor: zod_1.z.string().optional(),
    width: zod_1.z.number().gt(0).optional(),
}));
exports.LinePinComponentSchema = base_pin_component_1.BasePinComponentSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('LINE'),
    settings: LineSettingsSchema,
    position: zod_1.z.any(),
}));
//# sourceMappingURL=line-pin-component.js.map